var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        width: "1000px",
        "custom-class": "ie-form-dialog",
        "append-to-body": "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "fd-head" }, [
        _c("span", { staticClass: "fd-ico" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: _vm.isAdd
                    ? "M12 5v14M5 12h14"
                    : "M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4z",
                },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "fd-title" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.isAdd ? "新增 IE 监控" : "编辑 IE 主体")),
          ]),
          _c("span", { staticClass: "fd-pt" }, [
            _vm._v(
              _vm._s(
                _vm.isAdd ? "Novo Monitoramento de IE" : "Editar Entidade de IE"
              )
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "fd-body" },
        [
          _vm.isAdd
            ? _c("div", { staticClass: "alert alert-info" }, [
                _c(
                  "svg",
                  {
                    staticClass: "ico",
                    attrs: {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                    },
                  },
                  [
                    _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                    _c("path", { attrs: { d: "M12 7.4v5.6" } }),
                    _c("circle", {
                      attrs: {
                        cx: "12",
                        cy: "16.6",
                        r: "1.15",
                        fill: "currentColor",
                        stroke: "none",
                      },
                    }),
                  ]
                ),
                _c("span", { staticClass: "alert-text" }, [
                  _c("span", [
                    _vm._v(
                      '录入后即加入监控列表，状态默认"未知"。系统会在 5 分钟内发起首次查询。'
                    ),
                  ]),
                  _c("span", { staticClass: "alert-pt" }, [
                    _vm._v(
                      ' Após o cadastro, entra na lista de monitoramento com status padrão "Desconhecido". A primeira consulta ocorre em até 5 minutos. '
                    ),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "alert alert-warn" }, [
                _c(
                  "svg",
                  {
                    staticClass: "ico",
                    attrs: {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                    },
                  },
                  [
                    _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                    _c("path", { attrs: { d: "M12 16v-4M12 8h.01" } }),
                  ]
                ),
                _c("span", { staticClass: "alert-text" }, [
                  _c("span", [
                    _vm._v("编辑前请先在 IE 信息管理列表将该主体"),
                    _c("b", [_vm._v("停用监控")]),
                    _vm._v("，确保定时查询不会在保存中途拉到旧数据。"),
                  ]),
                  _c("span", { staticClass: "alert-pt" }, [
                    _vm._v(
                      " Antes de editar, primeiro defina esta entidade como "
                    ),
                    _c("b", [_vm._v("Desativar Monitoramento")]),
                    _vm._v(
                      ", garantindo que a verificação agendada não leia dados desatualizados durante o salvamento. "
                    ),
                  ]),
                ]),
              ]),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "uf" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "UF", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _vm.isAdd
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder:
                                      "请选择州 / Selecione o estado",
                                  },
                                  model: {
                                    value: _vm.form.uf,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "uf", $$v)
                                    },
                                    expression: "form.uf",
                                  },
                                },
                                _vm._l(_vm.ufOptions, function (uf) {
                                  return _c("el-option", {
                                    key: uf.id,
                                    attrs: { label: uf.label, value: uf.label },
                                  })
                                }),
                                1
                              )
                            : _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.uf,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "uf", $$v)
                                  },
                                  expression: "form.uf",
                                },
                              }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "cnpj" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "CNPJ", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { placeholder: "00.000.000/0000-00" },
                            model: {
                              value: _vm.form.cnpj,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cnpj", $$v)
                              },
                              expression: "form.cnpj",
                            },
                          }),
                          _c("div", { staticClass: "hint" }, [
                            _vm._v(" 14 位数字，含校验位 "),
                            _c("span", { staticClass: "hint-pt" }, [
                              _vm._v(
                                "/ 14 dígitos, incluindo dígitos verificadores"
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "ie" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "IE", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: "州注册号 / Nº de registro estadual",
                            },
                            model: {
                              value: _vm.form.ie,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "ie", $$v)
                              },
                              expression: "form.ie",
                            },
                          }),
                          _c("div", { staticClass: "hint" }, [
                            _vm._v(" 9~14 位数字 "),
                            _c("span", { staticClass: "hint-pt" }, [
                              _vm._v("/ 9 a 14 dígitos"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  !_vm.isAdd
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "companyName" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("bi-label", {
                                    attrs: {
                                      zh: "公司名称",
                                      pt: "Razão Social",
                                      inline: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.isAdd,
                                  placeholder: "Razão Social",
                                },
                                model: {
                                  value: _vm.form.companyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "companyName", $$v)
                                  },
                                  expression: "form.companyName",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "city" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "城市", pt: "Cidade", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { placeholder: "Município（可选）" },
                            model: {
                              value: _vm.form.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "city", $$v)
                              },
                              expression: "form.city",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "bairro" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "区", pt: "Bairro", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { placeholder: "Bairro" },
                            model: {
                              value: _vm.form.bairro,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bairro", $$v)
                              },
                              expression: "form.bairro",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "numero" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "门牌号 Nº",
                                  pt: "Nº (Número)",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { placeholder: "Nº" },
                            model: {
                              value: _vm.form.numero,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "numero", $$v)
                              },
                              expression: "form.numero",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "logradouro" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "街道",
                                  pt: "Logradouro",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: "Ex: Av. Paulista, Rua das Flores",
                            },
                            model: {
                              value: _vm.form.logradouro,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "logradouro", $$v)
                              },
                              expression: "form.logradouro",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "validade" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "有效期限",
                                  pt: "Validade",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "YYYY-MM-DD",
                            },
                            model: {
                              value: _vm.form.validade,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "validade", $$v)
                              },
                              expression: "form.validade",
                            },
                          }),
                          _c("div", { staticClass: "hint" }, [
                            _vm._v(" " + _vm._s(_vm.validadeHint) + " "),
                            _c("span", { staticClass: "hint-pt" }, [
                              _vm._v("/ " + _vm._s(_vm.validadeHintPt)),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isAdd
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "enable" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("bi-label", {
                            attrs: {
                              zh: "启用监控",
                              pt: "Ativar Monitoramento",
                              inline: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "enable-row" },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.form.enable,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "enable", $$v)
                              },
                              expression: "form.enable",
                            },
                          }),
                          _c("span", { staticClass: "enable-tip" }, [
                            _vm._v(" 停用后该 IE 不参与定时查询及告警 "),
                            _c("span", { staticClass: "hint-pt" }, [
                              _vm._v(
                                " / Após a desativação, esta IE não participa das consultas agendadas nem dos alertas "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [
              _c("bi-label", {
                attrs: { zh: "取消", pt: "Cancelar", inline: "" },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.isAdd ? "保存并启动监控" : "保存修改") + " "
              ),
              _c("span", { staticClass: "btn-pt" }, [
                _vm._v(
                  "/ " +
                    _vm._s(
                      _vm.isAdd
                        ? "Salvar e Ativar Monitoramento"
                        : "Salvar Alterações"
                    )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }